module.exports = __webpack_public_path__ + "img/duplicate.bf7cd27d.svg";